import { Material } from "../services/materialService";

export const moneyMask = (value: string, prefix: string = 'R$') => {
    value = value.replace('.', '').replace(',', '').replace(/\D/g, '')

    var region = 'pt-BR';

    if(prefix === 'USD')
      region = 'en-US';

    const options = { minimumFractionDigits: 2 }
    const result = new Intl.NumberFormat(region, options).format(
      parseFloat(value) / 100
    )
    return `${prefix} ` + result
  }

export const maskCNPJCPF = (value: string) => {
  const v = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 14)

  if (/^\d+$/.test(v) && v.length <= 11) {
    return v
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
  }

  return v
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, "$1.$2")
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3")
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3/$4")
    .replace(/([A-Z0-9]{4})([A-Z0-9]{1,2})$/, "$1-$2")
}

type Multiselect = {
  name: string,
  id: Number | string
};

export const statusToFilter = (t: any): Multiselect[] => {
  return [
    {
      name: t('myOrders.intervalAll'),
      id: 0
    },
    {
      name: t('myOrders.uniparAnalysis'),
      id: 1
    },
    {
      name: t('myOrders.customerPendency'),
      id: 2
    },
    {
      name: t('myOrders.orderConfirmed'),
      id: 3
    },
    {
      name: t('myOrders.arrived'),
      id: 4
    },
    {
      name: t('myOrders.entered'),
      id: 5
    },
    {
      name: t('myOrders.loaded'),
      id: 6
    },
    {
      name: t('myOrders.invoiced'),
      id: 7
    },
    {
      name: t('myOrders.refused'),
      id: 8
    },
    {
      name: t('myOrders.changeAnalysis'),
      id: 10
    },
    {
      name: t('myOrders.cancellationAnalysis'),
      id: 11
    },
  ];
}

export async function getFileFromUrl(url: string, name: string) : Promise<File> {
  const response = await fetch(url);
  const data = await response.blob();
  const type = getMimeTypeFromExtension(name.split('.')[1]);
  return new File([data], name, {
    type: type,
  });
}

export function getMimeTypeFromExtension(extension = "txt") {
  if (extension[0] === ".") {
      extension = extension.substr(1);
  }
  return {
      "aac": "audio/aac",
      "abw": "application/x-abiword",
      "arc": "application/x-freearc",
      "avi": "video/x-msvideo",
      "azw": "application/vnd.amazon.ebook",
      "bin": "application/octet-stream",
      "bmp": "image/bmp",
      "bz": "application/x-bzip",
      "bz2": "application/x-bzip2",
      "cda": "application/x-cdf",
      "csh": "application/x-csh",
      "css": "text/css",
      "csv": "text/csv",
      "doc": "application/msword",
      "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "eot": "application/vnd.ms-fontobject",
      "epub": "application/epub+zip",
      "gz": "application/gzip",
      "gif": "image/gif",
      "htm": "text/html",
      "html": "text/html",
      "ico": "image/vnd.microsoft.icon",
      "ics": "text/calendar",
      "jar": "application/java-archive",
      "jpeg": "image/jpeg",
      "jpg": "image/jpeg",
      "js": "text/javascript",
      "json": "application/json",
      "jsonld": "application/ld+json",
      "mid": "audio/midi audio/x-midi",
      "midi": "audio/midi audio/x-midi",
      "mjs": "text/javascript",
      "mp3": "audio/mpeg",
      "mp4": "video/mp4",
      "mpeg": "video/mpeg",
      "mpkg": "application/vnd.apple.installer+xml",
      "odp": "application/vnd.oasis.opendocument.presentation",
      "ods": "application/vnd.oasis.opendocument.spreadsheet",
      "odt": "application/vnd.oasis.opendocument.text",
      "oga": "audio/ogg",
      "ogv": "video/ogg",
      "ogx": "application/ogg",
      "opus": "audio/opus",
      "otf": "font/otf",
      "png": "image/png",
      "pdf": "application/pdf",
      "php": "application/x-httpd-php",
      "ppt": "application/vnd.ms-powerpoint",
      "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "rar": "application/vnd.rar",
      "rtf": "application/rtf",
      "sh": "application/x-sh",
      "svg": "image/svg+xml",
      "swf": "application/x-shockwave-flash",
      "tar": "application/x-tar",
      "tif": "image/tiff",
      "tiff": "image/tiff",
      "ts": "video/mp2t",
      "ttf": "font/ttf",
      "txt": "text/plain",
      "vsd": "application/vnd.visio",
      "wav": "audio/wav",
      "weba": "audio/webm",
      "webm": "video/webm",
      "webp": "image/webp",
      "woff": "font/woff",
      "woff2": "font/woff2",
      "xhtml": "application/xhtml+xml",
      "xls": "application/vnd.ms-excel",
      "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "xml": "application/xml",
      "xul": "application/vnd.mozilla.xul+xml",
      "zip": "application/zip",
      "3gp": "video/3gpp",
      "3g2": "video/3gpp2",
      "7z": "application/x-7z-compressed"
  }[extension] || "application/octet-stream";
}

export const writeFobOrFcaOrDate = (incoterm: string, deliveryDate?: string) => {
  if (incoterm === 'FOB' || incoterm === 'FCA') {
    return incoterm ?? '-';
  } else {
    return deliveryDate ?? '-';
  }
}

export const productToSelect = (materials: Material[] | undefined, i18n: any): Multiselect[] => {
  const options: Multiselect[] = [];

  materials?.forEach(m => {
    const option: Multiselect = {
      id: m.materialCode,
      name: m.descriptions?.filter(d => d.language === i18n.language.toUpperCase())?.[0]?.description ?? m.descriptions?.filter(d => d.language === 'PT')?.[0]?.description ?? ''
    };

    options.push(option);
  });

  return options;
}
